module.exports = __webpack_public_path__ + "img/img_landing_camera.e097f514.png";